import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.grey100};
  align-items: center;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
`;

export const Title = styled.div`
  background: ${({ theme }) => theme.colors.grey100};
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  width: 85%;
`;
